import { Send } from '@mui/icons-material';
import { Chip } from '@mui/material';
import AutocompleteComponent from 'components/design-system/Autocomplete/Autocomplete';
import ButtonComponent from 'components/design-system/Button/Button';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import { useEffect, useState } from 'react';

export const InvitarNegocioARegistroForm = ({
  isSubmitting,
  setFieldValue,
  values,
  errors,
  touched
}) => {
  const [emails, setEmails] = useState(values.emails);
  const [inputEmail, setInputEmail] = useState('');

  const isEmailValido = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleAñadirEmail = input => {
    if (!input) return;

    const nuevoEmails = input
      .split(/[,\s]+/)
      .map(email => email.trim())
      .filter(email => isEmailValido(email) && !emails.includes(email));

    if (nuevoEmails.length > 0) {
      setEmails(prev => [...prev, ...nuevoEmails]);
    }

    setInputEmail('');
  };

  const handleEliminarEmail = email => {
    setEmails(prev => prev.filter(e => e !== email));
  };

  useEffect(() => {
    setFieldValue('emails', emails);
  }, [emails]);

  return (
    <div className="grid grid-cols-12 gap-5">
      <div className="col-span-12 lg:col-span-8">
        <AutocompleteComponent
          disableClearable
          multiple
          freeSolo
          options={[]}
          disabled={isSubmitting}
          value={values.emails}
          touched={touched && touched.emails ? true : false}
          isOptionEqualToValue={() => {}}
          inputValue={inputEmail}
          onChange={(event, newValue) => {
            setEmails(newValue.filter(email => isEmailValido(email)));
          }}
          onInputChange={(event, newInputValue) => {
            setInputEmail(newInputValue);
          }}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((email, index) => (
              <Chip
                {...getTagProps({ index })}
                key={email}
                label={email}
                onDelete={() => handleEliminarEmail(email)}
              />
            ))
          }
        >
          <InputComponent
            fullWidth
            disabled={isSubmitting}
            label={<LabelComponent>Emails</LabelComponent>}
            placeholder="Escribe emails separados por espacios o enter"
            onBlur={event => {
              handleAñadirEmail(event.target.value);
            }}
            onKeyDown={event => {
              if (
                event.key === 'Enter' ||
                event.key === ' ' ||
                event.key === ',' ||
                event.key === ';'
              ) {
                event.preventDefault();
                handleAñadirEmail(inputEmail);
              }
            }}
            touched={touched && touched.emails ? true : false}
            estado={
              errors.emails ? { tipo: 'error', mensaje: errors.emails } : null
            }
          />
        </AutocompleteComponent>
      </div>
      <div className="col-span-12 lg:col-span-4 lg:pt-0.5">
        <ButtonComponent
          form="invitar-a-registro"
          buttonType="submit"
          className="h-auto lg:mt-6"
          disabled={isSubmitting}
        >
          Enviar invitación <Send className="ml-4" />
        </ButtonComponent>
      </div>
    </div>
  );
};
